var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-visit-record-container"},[_vm._m(0),_c('el-card',[_c('visit-record-form')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('h2',[_vm._v("新增回访记录")])])
}]

export { render, staticRenderFns }